/**
 * PDP
 *
 * Javascript to be run on the PDP
 */
define([
    'jquery',
    'popupsUtil',
    'owlCarousel'
], ($, PopupsUtil, owlCarousel) => {
    const upperScreenLimit = 479; // The highest width that will still be displaying as a mobile site

    $(document).on('click', '[data-sizing-guide-trigger]', (e) => {
        e.preventDefault();
        const sizeType = $('[data-swatch-filters-container]').data('swatch-filters-container') || 'women';
        let $sizeGuide = $(`[data-sizeguide-information=${sizeType}]`);
        // Fall back if no type detected.
        if ($sizeGuide.length === 0) { $sizeGuide = $('.sizeguide-information').first(); }
        // Figure out how to change the block here...
        PopupsUtil.displayPopUp('Size Guide', $sizeGuide.html());
    });

    // Initialise the owl.carousel plugin for related products
    const $relatedProductsList = $('.related-products__list');
    $relatedProductsList.owlCarousel({
        items: 4, // Display 4 items by default
        itemsDesktopSmall: false, // Inherit from above - need to overwrite default value
        itemsTablet: [upperScreenLimit, 3], // Display 3 items when browser width <= upperScreenLimit
        itemsTabletSmall: false, // Inherit from above - need to overwrite default value
        itemsMobile: false, // Inherit from above - need to overwrite default value
        mouseDrag: false,
        rewindNav: false
    });

    // Attach mousewheel event that will scroll the related products if the mouse is over them when the event occurs
    $(document).on('mousewheel DOMMouseScroll', '.related-products__list', (e) => {
        // The mousewheel even doesn't exist in Firefox, so DOMMouseScroll is used instead. However, the number that is
        // returned will be inverse to that in Chrome. I.e. Scrolling in one direction on Chrome will return a negative number,
        // but scrolling in that same direction in Firefox will return a positive number. Little bit annoying.
        if (e.originalEvent.wheelDelta < 0 || e.originalEvent.detail > 0) {
            $relatedProductsList.trigger('owl.next');
        } else {
            $relatedProductsList.trigger('owl.prev');
        }
    });

    // Attach handler to submit event of add to cart form, to check if a product size has been selected
    $('#product_addtocart_form').on('submit', () => {
        const $swatchOptions = $('.swatch-attribute-options .swatch-option');
        // If there is only one size and that size is the "special" size that is for products that don't actually have a size,
        // then select that size. This is so that the product can still be added to the users cart, without them having
        // to select the size - which will be hidden from their view anyway.
        if ($swatchOptions.length === 1 && ($swatchOptions.attr('option-label') === 'XEAC000' || $swatchOptions.attr('option-label').toLowerCase() === 'each')) {
            $swatchOptions.trigger('click');
        }
    });
});
